var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMerge(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4.75c0-.416.335-.75.75-.75H6.508c.547 0 1.062.256 1.39.69l3.4 4.46c.047.063.122.1.2.1h3.944l-1.219-1.219a.75.75 0 011.06-1.06l2.5 2.5a.747.747 0 010 1.06l-2.5 2.5a.75.75 0 01-1.06-1.06l1.22-1.218h-3.948a.252.252 0 00-.2.1L7.897 15.31c-.33.435-.846.691-1.39.691H2.75a.748.748 0 01-.75-.75c0-.416.334-.75.75-.75H6.507a.252.252 0 00.2-.1l3.35-4.4-3.353-4.4a.252.252 0 00-.2-.1H2.75A.748.748 0 012 4.75z",
    fill: "#0D2976"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerge);
export default ForwardRef;